import { Field } from 'formik'

import EditEventFormTypeWrapper from './EditEventFormTypeWrapper'

const EditEventFormTextarea = ({headline, name, rows = 20}) => {

    return (
        <EditEventFormTypeWrapper headline={headline}>
            <div className='cover-letter'>
                <Field
                    id={name}
                    name={name}
                    as="textarea"
                    rows={rows}
                />
            </div>
        </EditEventFormTypeWrapper>
    )
}

export default EditEventFormTextarea